import { url } from '@exodus/fetch/url';
const SERVER = new URL('https://exolix.com');
const getExolitOrder = async (id, fetchival) => {
    const response = await fetchival(url `${SERVER}/api/v2/transactions/${id}`).get();
    if (!response) {
        throw new Error(JSON.stringify(response));
    }
    return response;
};
const getProviderOrder = async (providerOrder, fetchival) => {
    const orderInfo = await getExolitOrder(providerOrder.id, fetchival);
    return {
        orderId: orderInfo.id,
        depositAddress: orderInfo.depositAddress,
        depositAmount: String(orderInfo.amount),
        withdrawalAddress: orderInfo.withdrawalAddress,
    };
};
const exolitConfig = {
    lix: getProviderOrder,
    lixus: getProviderOrder,
};
export default exolitConfig;
